export default __webpack_public_path__ + "static/media/962.6073121e.png";